var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSticlaWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b8927fc0-1f4d-49de-8938-b72eade2c35c",
    "data-name": "sticla",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ae7e2ccf-0149-4c65-a24e-963cbc47fc38,.b86342a3-9b3b-4085-ab8b-91e0cf74027e{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}.b86342a3-9b3b-4085-ab8b-91e0cf74027e{stroke-width:10px;}.ae7e2ccf-0149-4c65-a24e-963cbc47fc38{stroke-width:5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sticla_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f49959f3-92d6-4bbf-99cc-9f0066aa0f47",
    "data-name": "fereastra"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "b86342a3-9b3b-4085-ab8b-91e0cf74027e",
    points: "28.75 195 195 195 195 5 5 5 5 111.18"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae7e2ccf-0149-4c65-a24e-963cbc47fc38",
    x1: 160.35,
    y1: 15.06,
    x2: 184.38,
    y2: 39.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae7e2ccf-0149-4c65-a24e-963cbc47fc38",
    x1: 131.29,
    y1: 16.18,
    x2: 183.26,
    y2: 68.15
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSticlaWhite);
export default __webpack_public_path__ + "static/media/sticla_white.21b6a418a731080248dc1feb4f0e2102.svg";
export { ForwardRef as ReactComponent };